import { FilterMatchMode } from "primereact/api";

export class ColorMatriz {
    model = {
        id: {
            value: null,
            export: false
        },
        nombre: {
            value: '',
            header: 'Nombre',
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            filterField: 'nombre',
            table: true,
            filter: true,
            sort: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        sigla: {
            value: '',
            header: 'Código',
            required: 'Campo requerido',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 4 caracteres',
            table: true,
            max: 100,
            min: 4,
        },
        empresa: {
            header: 'Empresa',
            value: null,
            required: 'Empresa es requerido',
            optionLabel: 'nombre',
            export: true,
            table: true,
            filter: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        plantilla: {
            header: 'Matriz',
            value: null,
            required: 'campo requerido',
            optionLabel: 'nombre',
            export: true,
            table: true,
            filter: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        tipo_negocio: {
            header: 'Área de negocio',
            value: null,
            required: 'Área de negocio es requerido',
            optionLabel: 'nombre',
            export: true,
            table: false,
            filter: false
        }
    }
    optionLabel = 'nombre';
}
